"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _image = _interopRequireDefault(require("cccisd-icons/image"));
var _cccisdLaravelResources = require("cccisd-laravel-resources");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ImagePickerBlock = function ImagePickerBlock(props) {
  var value = props.value,
    onChange = props.onChange;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ImagePicker, {
    value: value || 0,
    onChange: onChange,
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-default btn-sm"
    }, /*#__PURE__*/_react["default"].createElement(_image["default"], null))
  }), value && /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-danger btn-sm",
    type: "button",
    style: {
      marginLeft: '0.5em'
    },
    onClick: function onClick() {
      return onChange(null);
    }
  }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)));
};
ImagePickerBlock.propTypes = {
  value: _propTypes["default"].object,
  onChange: _propTypes["default"].func
};
var _default = exports["default"] = ImagePickerBlock;